module.exports = __webpack_public_path__ + "img/sld_mfm_ic_4_t1_b1_dark.c18a1ff8.svg";